
export function dateOffsetFromToday(offset) {
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return d;
}

export function weekdayOffsetFromToday(offset) {
  const d = new Date();
  const sundaysInOffset = (d.getDay() + offset) % 6;
  d.setDate(d.getDate() + offset + sundaysInOffset)
  return d;
}

export function removeTime(date) {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
}
